export default __webpack_public_path__ + "static/media/Pashtun.56952f25.jpg";